<p>registered-club-contents works!</p>
